module.exports = __webpack_public_path__ + "static/climate_icon-4bc6740c8fa29443b3b02f16a5640940.svg";